import { render, staticRenderFns } from "./iconDialog.vue?vue&type=template&id=4a027974&scoped=true"
import script from "./iconDialog.vue?vue&type=script&lang=js"
export * from "./iconDialog.vue?vue&type=script&lang=js"
import style0 from "./iconDialog.vue?vue&type=style&index=0&id=4a027974&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a027974",
  null
  
)

export default component.exports